import {
  TDocumentStatus,
  TDocumentType,
  TDocument,
} from '../../apis/documents/documents.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockDocument } from '../documents/documentMock';

function generateStaffDocument(index: number, docType: TDocumentType, name: string): TDocument {
  const statuses = [TDocumentStatus.VERIFIED, TDocumentStatus.PENDING, TDocumentStatus.REJECTED];
  const status = statuses[index % statuses.length];
  
  const docNameMap: Record<TDocumentType, string> = {
    [TDocumentType.BIRTH_CERTIFICATE]: `Birth Certificate - ${name}`,
    [TDocumentType.TRANSFER_CERTIFICATE]: `Transfer Certificate - ${name}`,
    [TDocumentType.AADHAR_CARD]: `Aadhar Card - ${name}`,
    [TDocumentType.PAN_CARD]: `PAN Card - ${name}`,
    [TDocumentType.PREVIOUS_MARKSHEET]: `Previous Marksheet - ${name}`,
    [TDocumentType.MEDICAL_CERTIFICATE]: `Medical Certificate - ${name}`,
    [TDocumentType.SALARY_SLIP]: `Salary Slip - ${name}`,
    [TDocumentType.RESIGNATION_LETTER]: `Resignation Letter - ${name}`,
    [TDocumentType.JOINING_LETTER]: `Joining Letter - ${name}`,
    [TDocumentType.PROMOTION_LETTER]: `Promotion Letter - ${name}`,
    [TDocumentType.LEAVE_LETTER]: `Leave Letter - ${name}`,
    [TDocumentType.PHOTO]: `Profile Photo - ${name}`,
    [TDocumentType.OTHER]: `Document - ${name}`,
    [TDocumentType.HR_DOCUMENT]: `HR Document - ${name}`,
  };
  
  const baseDate = new Date('2024-01-15');
  const submissionDate = new Date(baseDate.getTime() + index * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const verificationDate = status === TDocumentStatus.VERIFIED 
    ? new Date(baseDate.getTime() + (index + 1) * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    : undefined;
  
  // userId must match ids in mockUserDetailsList (userDetailListMock.ts: id = 9000000000 + index)
  return {
    ...mockDocument,
    documentId: `doc-${docType}-${index}`,
    userId: String(9000000000 + index),
    documentType: docType,
    documentName: docNameMap[docType] || `Document - ${name}`,
    submissionDate,
    verificationDate,
    status,
    remarks: status === TDocumentStatus.VERIFIED ? `Document verified successfully for ${name}` :
             status === TDocumentStatus.REJECTED ? `Document quality issues for ${name}` : undefined,
    fileUrl: `https://example.com/${docType}-${index}.pdf`,
    thumbnailUrl: docType === TDocumentType.PHOTO || docType === TDocumentType.AADHAR_CARD 
      ? `https://example.com/${docType}-${index}-thumb.jpg` : undefined,
    description: `${docNameMap[docType]} for staff member ${name}`,
    uploadedAt: mockUserAction,
  };
}

/** Staff document demo set: 15 rows with varied types and statuses. */
const staffDocumentRows: { docType: TDocumentType; name: string }[] = [
  { docType: TDocumentType.BIRTH_CERTIFICATE, name: 'Ramesh Agarwal' },
  { docType: TDocumentType.AADHAR_CARD, name: 'Priya Sharma' },
  { docType: TDocumentType.PAN_CARD, name: 'Arjun Kumar' },
  { docType: TDocumentType.JOINING_LETTER, name: 'Anjali Patel' },
  { docType: TDocumentType.SALARY_SLIP, name: 'Vikram Singh' },
  { docType: TDocumentType.PROMOTION_LETTER, name: 'Kavita Reddy' },
  { docType: TDocumentType.HR_DOCUMENT, name: 'Rajesh Mehta' },
  { docType: TDocumentType.MEDICAL_CERTIFICATE, name: 'Meera Iyer' },
  { docType: TDocumentType.LEAVE_LETTER, name: 'Amit Gupta' },
  { docType: TDocumentType.RESIGNATION_LETTER, name: 'Sunita Joshi' },
  { docType: TDocumentType.PHOTO, name: 'Ramesh Agarwal' },
  { docType: TDocumentType.OTHER, name: 'Priya Sharma' },
  { docType: TDocumentType.SALARY_SLIP, name: 'Arjun Kumar' },
  { docType: TDocumentType.PAN_CARD, name: 'Kavita Reddy' },
  { docType: TDocumentType.HR_DOCUMENT, name: 'Vikram Singh' },
];

export const mockStaffDocuments: TDocument[] = staffDocumentRows.map((row, i) =>
  generateStaffDocument(i, row.docType, row.name)
);
